var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTickExcellent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "21px",
    viewBox: "0 0 20 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons / circle-tick-filled@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Fives---01---Account",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.0.6---Continue-with-email---no-account---sign-up---set-password",
    transform: "translate(-19.000000, -332.000000)",
    fill: "#44AA19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons-/-circle-tick-filled",
    transform: "translate(19.000000, 332.697981)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99549526,0 C4.85343324,0.00491185605 0.552458793,3.90560898 0.0486805086,9.02109794 C-0.455097776,14.1365869 3.00239637,18.8007968 8.04478795,19.8079632 C10.982228,20.3917122 14.0267874,19.6292524 16.3419713,17.73007 C18.6571552,15.8308877 19.9994283,12.9947588 20,10.0009117 C19.9874542,4.48276382 15.5156257,0.0125412938 9.99549526,0 Z M14.0626722,8.32178619 L10.1476241,12.0306479 C9.84677039,12.3303423 9.42931285,12.5 8.99274261,12.5 C8.55617236,12.5 8.13871482,12.3303423 7.83786114,12.0306479 L5.99005079,10.2910933 C5.94369509,10.2417377 5.90482528,10.1865036 5.87456265,10.1269844 C5.79113674,9.93591394 5.83663553,9.71609074 5.99005079,9.56901402 C6.0938829,9.47818398 6.22983402,9.42744804 6.37116168,9.42678629 C6.50917415,9.42691949 6.64171482,9.4779284 6.74072375,9.56901402 L8.58853409,11.3304498 C8.80230559,11.522175 9.13698436,11.522175 9.35075586,11.3304498 L13.2542552,7.62158811 C13.3085941,7.57512915 13.3711424,7.53809531 13.4390363,7.51218216 C13.5033565,7.49593928 13.5710459,7.49593928 13.6353661,7.51218216 C13.7780202,7.51686011 13.91379,7.57142595 14.016477,7.66535049 C14.1106451,7.76035902 14.1641574,7.88514442 14.1666667,8.01544953 C14.1682855,8.12558566 14.131772,8.23320067 14.0626722,8.32178619 L14.0626722,8.32178619 Z",
    id: "Shape"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickExcellent);
export default __webpack_public_path__ + "static/media/tick-excellent.eb782bdbb8e60cee106b716e6c10c7bc.svg";
export { ForwardRef as ReactComponent };